import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CaptchaService {
  constructor(private http: HttpClient) {}

  validate(token: string) {
    return this.http.get(
      `https://api.codesender.pl/v1/Account/ValidateCaptcha?token=${token}`
    );
  }
}



// WEBPACK FOOTER //
// C:/Users/dtarc/source/repos/CODESENDER/web/src/app/captcha.service.ts